<template>
  <nav class="sb-topnav navbar navbar-expand navbar-dark bg-dark">
    <div class="navbar-brand"></div>
<!--         <button class="btn btn-link btn-sm order-1 order-lg-0" id="sidebarToggle" @click="toggleSideBar"><i class="fas fa-bars"></i></button>-->
    <div
      class="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-3 my-2 my-md-0"
    >
      <ul class="navbar-nav ml-auto ml-md-0">
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            id="userDropdown"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-user fa-fw"></i>
          </a>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="userDropdown"
          >
            <router-link to="/system/profile" class="dropdown-item"
              >Profile</router-link
            >
            <router-link to="/system/user-activities" class="dropdown-item"
              >Activity Log</router-link
            >
            <a class="dropdown-item" v-on:click="logout">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
import * as auth from "../services/auth.js";
import * as activity from "../services/activities.js";
export default {
  methods: {
    toggleSideBar() {
      // $("body").toggleClass("sidebar-toggled");
      $("#sidenavAccordion").toggleClass("toggled");
    },
    showLoadingAlert() {
      this.$swal({
        title: "Logging out",
        onBeforeOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick:()=>this.$swal.showLoading()
      });
    },
    showAlert(message){
      this.$swal({
        title : message,
        icon : "error"
      })
    },
    logout: async function () {
      this.showLoadingAlert();
      try{
        await auth.logout();
        await this.$store.commit('logout');

        this.$router.push("/");
        this.$swal.close();
      }catch(error){
        let message = error.response.data.message;
        this.showAlert(message);
      }
    },
  },
};
</script>